"use strict";

import _classCallCheck from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { arrayify, hexlify } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder"; // @TODO: Merge this with bytes

export var FixedBytesCoder = /*#__PURE__*/function (_Coder) {
  _inherits(FixedBytesCoder, _Coder);

  var _super = _createSuper(FixedBytesCoder);

  function FixedBytesCoder(size, localName) {
    var _this;

    _classCallCheck(this, FixedBytesCoder);

    var name = "bytes" + String(size);
    _this = _super.call(this, name, name, localName, false);
    _this.size = size;
    return _this;
  }

  _createClass(FixedBytesCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      var data = arrayify(value);

      if (data.length !== this.size) {
        this._throwError("incorrect data length", value);
      }

      return writer.writeBytes(data);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, hexlify(reader.readBytes(this.size)));
    }
  }]);

  return FixedBytesCoder;
}(Coder);